import { Component, Input, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material";
import { RecommendationInterface } from "app/recommendation/models/recommendation.model";
import { GlobalConstants } from "app/shared/constants/globalconstants";
import { getBackupLanguageValue } from "app/shared/utilities/backup-language.utitlity";
import { SiteSupportedLanguageInterface } from "app/site-settings/models/site-supported-language.model";
import { CookieService } from "ngx-cookie-service";
import { BehaviorSubject } from "rxjs";

import { RecommendationCardDialogComponent } from "../recommendation-card-dialog/recommendation-card-dialog.component";

@Component({
  selector: "cz-recommendation-card",
  templateUrl: "./recommendation-card.component.html",
  styleUrls: ["./recommendation-card.component.scss"],
})
export class RecommendationCardComponent implements OnInit {
  @Input()
  public recommendation: RecommendationInterface;

  public detailString: string = undefined;

  @Input() public cultureCookie: number;
  @Input() public backupLanguageId: number;
  public supportedlanguage$: BehaviorSubject<SiteSupportedLanguageInterface[]>;

  constructor(
    public dialog: MatDialog,
    private readonly _cookieService: CookieService,
    private readonly _GlobalConstants: GlobalConstants,
  ) {
    this.supportedlanguage$ = new BehaviorSubject<
      SiteSupportedLanguageInterface[]
    >(undefined);
  }

  public ngOnInit(): void {}

  public openRecommendationDialog(showCommentsInDialog?: boolean): void {
    const dialogData: any = {
      recommendation: this.recommendation,
      showComments: showCommentsInDialog,
    };
    this.dialog.open(RecommendationCardDialogComponent, {
      height: "600px",
      width: "800px",
      data: dialogData,
    });
  }

  public getBackupValue(field: string, object: any, isConvertion: any) {
    if (field == "text") {
      const dotsString =
        getBackupLanguageValue(
          field,
          object,
          this._GlobalConstants.cultureCookieId,
          isConvertion,
          this._GlobalConstants.backupLanguageId,
        ) + "<span>...<span>";
      if (dotsString.length > 60) {
        return dotsString;
      }
      return getBackupLanguageValue(
        field,
        object,
        this._GlobalConstants.cultureCookieId,
        isConvertion,
        this._GlobalConstants.backupLanguageId,
      );
    }
    return getBackupLanguageValue(
      field,
      object,
      this._GlobalConstants.cultureCookieId,
      isConvertion,
      this._GlobalConstants.backupLanguageId,
    );
  }
}
